// client/src/data/products.js
import saree1 from "../assets/images/BestSellers/Sarees/Rectangle 18-Photoroom.png";
import saree2 from "../assets/images/BestSellers/Sarees/Rectangle 19329-Photoroom.png";
import saree3 from "../assets/images/BestSellers/Sarees/Rectangle 19330-Photoroom.png";
// Note: other images (men/home) are kept as public paths to avoid breaking builds
// (move them into src/assets and import similarly if you want bundling)

const products = [
  // SAREES
  {
    _id: "1",
    name: "Red Silk Saree",
    image: saree1,
    category: "Sarees",
    categorySlug: "sarees",
    isBestSeller: true,
  },
  {
    _id: "2",
    name: "Yellow Cotton Saree",
    image: saree2,
    category: "Sarees",
    categorySlug: "sarees",
    isBestSeller: false,
  },
  {
    _id: "3",
    name: "Pink Designer Saree",
    image: saree3,
    category: "Sarees",
    categorySlug: "sarees",
    isBestSeller: true,
  },

  // MENS
  {
    _id: "4",
    name: "Men Kurta",
    image: "/images/men1.png",
    category: "Mens",
    categorySlug: "mens",
    isBestSeller: true,
  },
  {
    _id: "5",
    name: "Men Shirt",
    image: "/images/men2.png",
    category: "Mens",
    categorySlug: "mens",
    isBestSeller: false,
  },

  // HOME
  {
    _id: "6",
    name: "Bedsheet Set",
    image: "/images/home1.png",
    category: "Home",
    categorySlug: "home",
    isBestSeller: true,
  }
];

export default products;